import * as postActions from 'spa/components/../action_creators/posts'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import { Heading, TextStyle } from 'spa/components/typography'
import { Helmet } from 'react-helmet'
import { Link } from 'spa/components/link'
import { Loading } from 'spa/components/loading'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles'

const NEWS_URL = 'news.djcity.com'

const localizedMessages = defineMessages({
  lightsOut: {
    id: 'djcity.common.images.lights_out',
    defaultMessage: '/assets/cdn/djcity_lights_out.png',
  },
  faqVideo: {
    id: 'djcity.common.faq.video.url',
    defaultMessage: 'https://www.youtube.com/watch?v=qvey8OaCXOs',
  },
  notFound: {
    id: 'djcity.common.page.not_found',
    defaultMessage: 'Page not found | DJcity',
  },
})

class PostRoutes extends React.PureComponent {
  static propTypes = {
    fetchPosts: PropTypes.func,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    locale: PropTypes.string.isRequired,
    match: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
    posts: PropTypes.arrayOf(PropTypes.object),
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.props.fetchPosts()
  }

  // If domain news.djcity.com, append lang parameter with formatted
  // locale, en_us, ja_jp
  processLink = (url, locale) => {
    const parsedUrl = new URL(url)
    const domain = parsedUrl.hostname
    if (domain !== NEWS_URL) {
      return parsedUrl
    }

    if (parsedUrl.pathname?.startsWith('/tag/')) {
      const mapping = {
        'en-US': '',
        'en-GB': '/eu',
        'es-ES': '/latino',
        'ja-JP': '/jp',
        'de-DE': '/de',
      }
      parsedUrl.pathname = `${mapping[locale]}${parsedUrl.pathname}`
    } else {
      const formattedLocale = locale.replace('-', '_').toLowerCase()
      parsedUrl.searchParams.set('lang', formattedLocale)
    }

    return parsedUrl
  }

  render() {
    const {
      match: { url },
      posts: { items, isFetching },
      intl,
      locale,
    } = this.props
    if (isFetching) {
      return <Loading />
    }
    const post = items[url]
    if (post) {
      const url = this.processLink(post.external_link, locale)
      return (
        <div className={styles.container}>
          <iframe className={styles.iframeContainer} src={url} />
        </div>
      )
    } else {
      return (
        <div className={styles.container404}>
          <img
            className={styles.image}
            src={intl.formatMessage(localizedMessages.lightsOut)}
          ></img>
          <div className={styles.page404}>
            <Helmet defer={false}>
              <title key="pagetitle">
                {intl.formatMessage(localizedMessages.notFound)}
              </title>
            </Helmet>
            <Heading className={styles.heading}>
              <FormattedMessage
                defaultMessage="Sorry, we can't seem to find this page"
                id="djcity.common.not_found"
              />
            </Heading>
            <TextStyle className={styles.subtitle} color="black">
              <FormattedMessage
                defaultMessage="Go to DJcity.com's"
                id="djcity.common.not_found.go_to_djcity"
              />{' '}
              <Link className={styles.link} to="/">
                <FormattedMessage
                  defaultMessage="Home Page"
                  id="djcity.common.home_page"
                />
              </Link>
            </TextStyle>
          </div>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
    posts: state.posts,
    locale: state.locale.locale,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchPosts: bindActionCreators(postActions, dispatch).fetchAll,
  }
}

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(PostRoutes))
)
